import { useMemo } from 'react'
import { byStartDateAsc } from '../../lib/utils'
import { isEventActive } from '../../lib/formatDate'
import type { Event } from '../../types'
import type { BrowseType } from './browseType'
import type { FriendEventInterestBuckets } from '../../hooks/useFriendEventInterests'

export interface BrowseSections {
  upcoming: Event[]
  /** Distinct friends going to or interested in each event — the Relevance crew boost. */
  crewCounts: Map<string, number>
}

export function useBrowseSections(
  events: Event[],
  type: BrowseType,
  friendInterests: Map<string, FriendEventInterestBuckets>,
  explicitFriendIds: string[],
  now: Date,
): BrowseSections {
  return useMemo(() => {
    const upcoming = events.filter(e => (type === 'all' || e.type === type) && isEventActive(e, now)).sort(byStartDateAsc)

    const friends = new Set(explicitFriendIds)
    const crewCounts = new Map<string, number>()
    friendInterests.forEach((buckets, eventId) => {
      const n = new Set([...buckets.going, ...buckets.interested].filter(id => friends.has(id))).size
      if (n > 0) crewCounts.set(eventId, n)
    })

    return { upcoming, crewCounts }
  }, [events, type, friendInterests, explicitFriendIds, now])
}
